import { useState } from "react";
import { GrFormPrevious } from "react-icons/gr";
import Media from "./Media/Media";
import Links from "./Links/Links";
import Documents from "./Documents/Documents";

export default function MediaLinks({ setActiveSection, setShowProfileView }) {
  const [activeTab, setActiveTab] = useState("Media");

  const tabs = ["Media", "Links", "Documents"];

  const renderContent = () => {
    switch (activeTab) {
      case "Media":
        return (
          <div>
            <Media />
          </div>
        );
      case "Links":
        return (
          <div>
            <Links />
          </div>
        );
      case "Documents":
        return (
          <div>
            <Documents />
          </div>
        );
      default:
        return null;
    }
  };
  return (
    <section>
      <div className="sticky  w-full min-h-[60px] py-2.5 bg-white flex items-center justify-between border-b  text-black p-4 text-center">
        <div className="">
          <div className="w-full items-center bg-white text-black flex gap-4 ">
            <GrFormPrevious
              onClick={() => setActiveSection("contact")}
              className="cursor-pointer hover:text-[var(--primary-color)] h-8 w-8 p-1  border rounded-md"
            />
          </div>
        </div>
      </div>
      <div className="bg-[#fff] justify-center h-[calc(100vh-80px)] min-h-[calc(100vh-80px)]
max-h-[calc(100vh-80px)] gap-2 overflow-y-auto overflow-x-hidden">
        <div className="flex bg-[#f9f6fe] items-center gap-2 p-1 pt-0">
          <div className="bg-white rounded-lg w-full px-0 pb-0 pt-2">
            <div className="grid grid-cols-3 gap-2">
              {tabs.map((tab) => (
                <button
                  key={tab}
                  onClick={() => setActiveTab(tab)}
                  className={`w-full py-2 font-medium text-sm transition-all  ${
                    activeTab === tab
                      ? "border-b-2 border-[#7104F8] text-[#7104F8] font-medium"
                      : "border-b-2 border-white text-gray-700"
                  }`}
                >
                  {tab}
                </button>
              ))}
            </div>
          </div>
        </div>

        <div className="p-4">{renderContent()}</div>
      </div>
    </section>
  );
}
